// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TokenPlans__title-sec{margin-bottom:8px;display:flex;align-items:center;gap:5px}.TokenPlans__tooltip{font-size:11px;white-space:nowrap}.darkmode .TokenPlans__tooltip{background-color:#fff;border:unset}.TokenPlans__tokenPlans{margin-bottom:5px}.TokenPlans__tokenPlans .cb-list{display:flex;flex-direction:column;gap:8px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
